import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_RECURRINGTICKETS } from "../../../utils/constants";
import { TicketInterface } from "../../../models/TicketModule/Ticket";
import ticketService from "../../../services/ticketService/ticketService";

interface UpdateTicketsContext {
  previousTickets: TicketInterface[];
}

const useUpdateRecTicket = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    TicketInterface,
    Error,
    TicketInterface,
    UpdateTicketsContext
  >({
    mutationFn: async (ticket: TicketInterface) => {
      const { id, ...ticketData } = ticket;
      return ticketService.Update(id || "", ticketData);
    },

    onMutate: async (updatedTicket: TicketInterface) => {
      await queryClient.cancelQueries({
        queryKey: [CACHE_KEY_RECURRINGTICKETS, page, pageSize],
      });

      const previousTickets =
        queryClient.getQueryData<TicketInterface[]>([
          CACHE_KEY_RECURRINGTICKETS,
          page,
          pageSize,
        ]) || [];

      queryClient.setQueryData<TicketInterface[]>(
        [CACHE_KEY_RECURRINGTICKETS, page, pageSize],
        (tickets = []) =>
          tickets.map((ticket) =>
            ticket.id === updatedTicket.id ? updatedTicket : ticket
          )
      );

      return { previousTickets };
    },

    onSuccess: (savedTicket) => {
      queryClient.setQueryData<TicketInterface[]>(
        [CACHE_KEY_RECURRINGTICKETS, page, pageSize],
        (tickets) =>
          tickets?.map((ticket) =>
            ticket.id === savedTicket.id ? savedTicket : ticket
          )
      );
    },

    onError: (error, updatedTicket, context) => {
      if (!context) return;

      queryClient.setQueryData<TicketInterface[]>(
        [CACHE_KEY_RECURRINGTICKETS, page, pageSize],
        context.previousTickets
      );
    },
  });
};

export default useUpdateRecTicket;
